import React from 'react';
import styled from 'styled-components';

export interface WorkViewerShellProps {
  children: React.ReactNode;
  onDragEnter?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
}

const WorkViewerShell: React.FC<WorkViewerShellProps> = ({
  children,
  onDragEnter,
  onDragOver,
  onDrop,
}) => (
    <Shell
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {children}
    </Shell>
);

const Shell = styled.section`
  position: relative;
  width: 29vw;
  height: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  padding-bottom: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

export default WorkViewerShell;
